import type { Theme } from '../types';

export const DEFAULT_THEME: Theme = {
  primary: '#e1cdbf',
  secondary: '#1f1b17',
  text: '#1f1b17',
  hover: '#d4bcac',
  accent: '#efe2d8',
  header: '#e1cdbf',
};
